const NAME_LENGTH_THRESHOLD = 24;

function shortenScheduleName(name, countries) {
    if (!name || name.length <= NAME_LENGTH_THRESHOLD || !countries?.length) {
        return name;
    }
    let shortened = countries.join(", ");
    if (shortened.length > NAME_LENGTH_THRESHOLD && countries.length >= 2) {
        shortened = countries.slice(0, countries.length - 1).join(", ") + " …";
    }
    return shortened;
}

export { NAME_LENGTH_THRESHOLD, shortenScheduleName };
